import { doc, getDoc, setDoc, updateDoc, serverTimestamp } from "firebase/firestore";
import { auth, db } from "@/lib/firebase";

/**
 * Read whether the user has "auto locate on login" enabled.
 */
export async function getAutoLocationOnLogin(): Promise<boolean> {
  const uid = auth.currentUser?.uid;
  if (!uid) return false;

  const snap = await getDoc(doc(db, "users", uid));
  if (!snap.exists()) return false;

  const v = snap.get("locationPreference.autoOnLogin");
  return Boolean(v);
}

/**
 * Set "auto locate on login" preference for the signed-in user.
 */
export async function setAutoLocationOnLogin(next: boolean): Promise<void> {
  const uid = auth.currentUser?.uid;
  if (!uid) throw new Error("Not signed in");

  const ref = doc(db, "users", uid);
  try {
    await updateDoc(ref, {
      "locationPreference.autoOnLogin": next,
      updatedAt: serverTimestamp(),
    });
  } catch (err: any) {
    // Handle doc not found (create it), otherwise rethrow
    if (err?.code === "not-found") {
      await setDoc(
        ref,
        {
          locationPreference: { autoOnLogin: next },
          updatedAt: serverTimestamp(),
        },
        { merge: true }
      );
    } else {
      throw err;
    }
  }
}

